/*
 * File: index.ts
 * Author: Austin Robinson
 * Date Created: 9/10/2022
 * Copyright (c) DrivingDoc 2022
 */
import { useState } from 'react';

import {
  createCoursePeriodsMutation,
  deleteCoursePeriodsMutation as deleteCoursePeriodsMutationOptions,
  listInstructorsOptions,
  listCoursePeriodsOptions,
} from '@drivingdoc/api-client/generated/react-query';
import { useMutation, useQuery } from '@tanstack/react-query';
import { CalendarCoursePeriod, GetAllCoursePeriodsParams } from 'types/periods';
import { Instructor } from 'types/instructors';

export default function useCalendarData() {
  const [calendarFilter, setCalendarFilter] = useState<GetAllCoursePeriodsParams | undefined>(undefined);

  const { data: instructors } = useQuery(
    listInstructorsOptions({
      query: {
        status: 'both',
      },
    }),
  );
  const instructorRows = (instructors as Instructor[] | undefined) ?? [];

  const { data: coursePeriods } = useQuery({
    ...listCoursePeriodsOptions({
      query: {
        start: calendarFilter?.start ?? '',
        end: calendarFilter?.end ?? '',
      },
    }),
    enabled: !!calendarFilter,
  });
  const calendarCoursePeriods = coursePeriods as CalendarCoursePeriod[] | undefined;

  const submitNewDrives = useMutation(createCoursePeriodsMutation());

  const deleteCoursePeriodsMutation = useMutation(deleteCoursePeriodsMutationOptions());

  // const registerStudentsForDrive = useMutation(async ({ driveID, studentIDs }: RegisterStudentParams) => {
  //   // const mutationParams = {
  //   //   input: {
  //   //     driveID,
  //   //     studentID: studentIDs[0], // todo temp while using one student
  //   //     canceled: false,
  //   //   },
  //   // };
  //   // const newRegistration = (API.graphql(graphqlOperation(createStudentDrive, mutationParams)) as any);
  //   // return newRegistration;
  //   const temp = undefined;
  //   return temp as any;
  // });

  return {
    calendarFilter: calendarFilter,
    setCalendarFilter,
    instructors: instructorRows,
    coursePeriods: calendarCoursePeriods,
    submitNewDrives,
    deleteCoursePeriodsMutation,
    // registerStudentsForDrive,
  };
}
